import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { CircleIconList, CircleIconListItem, } from '@/components/ui/List/IconList/CircleIconList';
import { Text } from '@/components/ui/Typography/Body/Text';
import { RFP_OFFER_MEMBER_INVOLVEMENTS } from '@/utils/constants/rfp/rfpOfferMember/involvement';
import { RFP_OFFER_MEMBER_ROLES } from '@/utils/constants/rfp/rfpOfferMember/role';
import { RFP_OFFER_MEMBER_STATUS_OFFER_MEMBER } from '@/utils/constants/rfp/rfpOfferMember/status';
/**
 * 案件メンバー情報の表示
 * @param props
 * @returns
 */
export const RfpProOfferMemberList = (props) => {
    const { className = '', members: rawMembers } = props;
    const members = useMemo(() => rawMembers
        .filter((member) => member.status === undefined ||
        member.status === RFP_OFFER_MEMBER_STATUS_OFFER_MEMBER.value)
        .map((member) => {
        var _a, _b;
        return (Object.assign(Object.assign({}, member), { involvement: ((_a = RFP_OFFER_MEMBER_INVOLVEMENTS.find((involvement) => involvement.value === member.involvement)) === null || _a === void 0 ? void 0 : _a.label) || '-', role: ((_b = RFP_OFFER_MEMBER_ROLES.find((role) => role.value === member.role)) === null || _b === void 0 ? void 0 : _b.label) || '-' }));
    }), [rawMembers]);
    return (_jsx(CircleIconList, Object.assign({ className: className }, { children: members.map((member, index) => (_jsxs(CircleIconListItem, { children: [_jsx(Text, Object.assign({ color: 'none', isBold: true, size: 'none' }, { children: member.last_name && member.first_name
                        ? `${member.last_name} ${member.first_name}`.trim()
                        : member.email })), _jsx("div", { children: `役割：${member.role}` }), _jsx("div", { children: `関わり方：${member.involvement}` })] }, `CircleIconListItem_${index + 1}`))) })));
};
